function FooterSection(){
    return (
        <>
         <footer class="footer">
            <div class="container">
              <div class="d-sm-flex justify-content-center justify-content-sm-between">
                <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © DISTRIFORCE 2024</span>
                <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"> Plus d'information <a href="https://softexpertise.com/" target="_blank">SOFTEXPERTISE.CI</a></span>
              </div>

              <div>
                <span class="text-muted d-block text-center text-sm-left d-sm-inline-block"> Distributed By: <a href="https://softexpertise.com/" target="_blank">SOFTEXPERTISE</a></span>
              </div>
            </div>
          </footer>
        </>
    );
}

export default FooterSection;